import Axios from 'config/api';
import toast from 'react-hot-toast';
import { setUpdateLoading , updateDoc , setDeleteLoading, addDoc,setCreateLoading } from 'redux/slices/adminSlice';
import toastError from 'utils/toastError';

const url = '/user';
const navigateUrl = '/app/panel-user'

export const admin_createDoc = (data , navigate) => async (dispatch) => {
    dispatch(setCreateLoading(true))
    try {
        const { data : { data : { doc , message } } } = await Axios.post(`${url}/register-admin-user` , data);
        dispatch(addDoc(doc));
        toast.success(message);
        navigate(navigateUrl)
        dispatch(setCreateLoading(false));
    } catch (err) {
        dispatch(setCreateLoading(false));
        console.log('error' , err);
        toastError(err)
    }
}

export const admin_edit = (itemId , updateData , navigate) => async (dispatch , getState) => {
    dispatch(setUpdateLoading(true))
    try {
        const { data : { data : { doc , message } } } = await Axios.put(`${url}/${itemId}` , updateData );
        toast.success(message)
        dispatch(updateDoc(doc));
        if(navigate) {
            navigate(navigateUrl)
        }
        dispatch(setUpdateLoading(false));
    } catch (err) {
        dispatch(setUpdateLoading(false));
        console.log('error' , err);
        toastError(err)
    }
}

// export const admin_delete = (itemId) => async (dispatch , getState) => {
//     dispatch(setDeleteLoading(true))
//     try {
//         const { data : { data : { doc , message } } } = await Axios.put(`${url}/${itemId}`);
//         toast.success(message)
//         dispatch(updateDoc(doc));
//         dispatch(setDeleteLoading(false));
//     } catch (err) {
//         dispatch(setDeleteLoading(false));
//         console.log('error' , err);
//         toastError(err);
//     }
// }





export const admin_delete = (itemId) => async (dispatch , getState) => {
    dispatch(setDeleteLoading(true))
    try {
        const { data : { data : { doc , message } } } = await Axios.delete(`${url}/${itemId}`);
        toast.success(message)
        dispatch(setDeleteLoading(false));
    } catch (err) {
        dispatch(setDeleteLoading(false));
        console.log('error' , err);
        toastError(err);
    }
}
